import { useEffect, useState } from "react"
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Chip from '@mui/material/Chip';
import AddIcon from '@mui/icons-material/Add';
import { DataGrid,GridToolbarQuickFilter } from '@mui/x-data-grid';
import KeyIcon from '@mui/icons-material/Key';
import Modal from "../Modal/Modal";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import functions  from "../../functions/functions";
import './BackendSecrets.scss'
import Cookies from 'universal-cookie';
import DeleteIcon from '@mui/icons-material/Delete';
export default function BackendSecrets({ env ,secrets }) {

  const theme = useTheme();

  const [rows, setRows] = useState(secrets);
  const[open_create_new_backend_secret,set_open_create_new_backend_secret] = useState(false)
  const [secret_key,set_secret_key] = useState("")
  const [open_backend_edit_modal,set_open_backend_edit_modal] = useState(false)
  const [secret_value,set_secret_value] = useState("")
  const [value, setValue] = useState(3);
  const [open_backend_delete_modal,set_open_backend_delete_modal] = useState(false)
  const [filterModel, setFilterModel] = useState({
    items: [
      {
        columnField: 'action',
        operatorValue: 'contains',
        value: ""
      },
    ],
  });
  function QuickSearchToolbar() {
    return (
        <GridToolbarQuickFilter />
    );
  }
  const handle_close_modal = () => {
    set_open_backend_edit_modal(false);
    set_open_create_new_backend_secret(false);
    set_open_backend_delete_modal(false);

  };
  useEffect(() => {
    setRows(secrets)
  }, [secrets]);


  function update_filter(cellData,param){
    if(filterModel.items[0]?.value==cellData.row[param]){
      setFilterModel({
        items: [
          {
            columnField: param,
            operatorValue: 'contains',
            value: ""
          },
        ],
      })
    }
    else{
      setFilterModel({
        items: [
          {
            columnField: param,
            operatorValue: 'contains',
            value: cellData.row[param]
          },
        ],
      })
    }
  }
  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography component={'span'} variant={'body2'}>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function update_backend_secret(env ,secret_key , secret_value ){
    const cookies = new Cookies();
    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "google_code": cookies.get("google_code"),
      "env" : env ,
      "key" : secret_key ,
      "value" : secret_value , 
      "code" : cookies.get("code")
    })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/google/update_backend_secret/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
      }
      catch(error) {
        console.log(error)
      }
    });
    let new_secrets = rows;
    if(open_create_new_backend_secret){
      new_secrets =[...new_secrets , {key:secret_key , value:"*****"}]
    }
    setRows(new_secrets)
    handle_close_modal();
    set_secret_value("")
  }

  function update_debugger_secret(){
    const cookies = new Cookies();
    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "userName" : cookies.get("login") ,
      "key" : secret_key ,
      "value" : secret_value , 
    })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/debugger/updateConsts/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
      }
      catch(error) {
        console.log(error)
      }
    });
    let new_secrets = rows;
    handle_close_modal();
    new_secrets = new_secrets.filter((secret)=>secret.key!=secret_key);
    if(open_create_new_backend_secret){
    new_secrets =[...new_secrets , {key:secret_key , value:secret_value}]
    }
    setRows(new_secrets)
    set_secret_value("")
  }


  function update_secret(env ,secret_key , secret_value ){
    if(env!="debugger"){
      update_backend_secret(env ,secret_key , secret_value)
    }
    else{
      update_debugger_secret(env ,secret_key , secret_value)
    }
  }

  function delete_backend_secret(env ,secret_key , secret_value ){
    const cookies = new Cookies();
    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "google_code": cookies.get("google_code"),
      "env" : env ,
      "key" : secret_key ,
      "value" : null ,
      "code" : cookies.get("code")
    })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/google/update_backend_secret/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
      }
      catch(error) {
        console.log(error)
      }
    });
    let new_secrets = rows.filter((secret)=>secret.key!=secret_key);
    setRows(new_secrets)
    handle_close_modal();
    set_secret_value("")

  }

  function delete_secret(env ,secret_key , secret_value){
    if(env!="debugger"){
      delete_backend_secret(env ,secret_key , secret_value)
    }
    else{
      delete_debugger_secret(env ,secret_key , secret_value)
    }
  }

  function delete_debugger_secret(env ,secret_key , secret_value){
    const cookies = new Cookies();
    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "userName" : cookies.get("login") ,
      "key" : secret_key ,
      "value" : secret_value , 
    })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/debugger/deleteConsts/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
      }
      catch(error) {
        console.log(error)
      }
    });
    let new_secrets = rows.filter((secret)=>secret.key!=secret_key);
    setRows(new_secrets)
    handle_close_modal();
    set_secret_value("")

  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };
  
  const envs_columns = [
    { field: 'key', headerName: 'Key', width: 300},
    { field: 'value', headerName: 'value', width: 300 } ,
    {
      field: "edit",
      headerName: "Edit",
      filterable: false,
      sortable: false,
      width: 200,
      renderCell: (params) => {
        return (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer", zIndex:10000 , position: "relative"}}
          >
            <ModeEditOutlineOutlinedIcon index={params.row.id} />
          </div>
        );
      }
    },
    {
      field: "delete",
      headerName: "Delete",
      filterable: false,
      sortable: false,
      width: 200,
      renderCell: (params) => {
        return (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer", zIndex:10000 , position: "relative"}}
          >
            <DeleteIcon index={params.row.id} />
          </div>
        );
      }

    }
  ]

  return (
      <div style={{ backgroundColor: "white" , height: "40em" , cursor: "pointer" }}>
          <TabPanel value={value} index={3} dir={theme.direction} className="service_details">
          <div style={{"marginBottom" : "1em"}}>
            <Chip icon={<AddIcon fontSize="large"/>} label="Add new" style={{"cursor" : "pointer"}} onClick={()=>set_open_create_new_backend_secret(true)}/>
            {env=="app" &&
              <Chip icon={<KeyIcon fontSize="large"/>} label="Link" style={{"cursor" : "pointer" , "float": "right"}} onClick={() => window.open(`https://console.cloud.google.com/security/secret-manager/secret/${env}-backend/versions?project=${process.env.REACT_APP_GCP_PROD_SECRET_PROJECT}`, '_blank', 'noreferrer')}/>
            }
            {env!="app" && env!="debugger" &&
              <Chip icon={<KeyIcon fontSize="large"/>} label="Link" style={{"cursor" : "pointer" , "float": "right"}} onClick={() => window.open(`https://console.cloud.google.com/security/secret-manager/secret/${env}-backend/versions?project=${process.env.REACT_APP_GCP_STAGING_SECRET_PROJECT}`, '_blank', 'noreferrer')}/>
            }
          </div>
          <div style={{ backgroundColor: "white" , height: "40em" , cursor: "pointer" }} >
            <DataGrid
              rows={rows}
              columns={envs_columns}
              getRowId={(row) => row.key}
              filterModel={filterModel}
              onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
              pageSize={100}
              rowsPerPageOptions={[100]}
              sx={{
                boxShadow: 2,
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
              }}
              components={{ Toolbar: QuickSearchToolbar }}
              disableSelectionOnClick={true}
              onCellClick={(cellData) => {
                if(cellData.field=="google_link"){
                  if(cellData.row.secret_name.includes("app")){
                    window.open(`https://console.cloud.google.com/security/secret-manager/secret/${cellData.row.secret_name}/versions?project=${process.env.REACT_APP_GCP_PROD_SECRET_PROJECT}`, '_blank', 'noreferrer')
                  }
                  else{
                    window.open(`https://console.cloud.google.com/security/secret-manager/secret/${cellData.row.secret_name}/versions?project=${process.env.REACT_APP_GCP_STAGING_SECRET_PROJECT}`, '_blank', 'noreferrer')
                  }
                }
                else if(cellData.field=="edit"){
                  set_open_backend_edit_modal(true)
                  set_secret_key(cellData.row.key)
                }
                else if(cellData.field=="delete"){
                  set_open_backend_delete_modal(true)
                  set_secret_key(cellData.row.key)
                }
                else{
                  update_filter(cellData,cellData.field)
                }
            }}
            />
          </div>
        </TabPanel>
        <Modal open={open_create_new_backend_secret} onClose={()=>handle_close_modal} 
          title={"New secret"}
          text={"to edit the secret, please write the new value"}
          textField={true}
          textFieldLabel={"key"}
          textFieldSetText={set_secret_key}
          textField2={true}
          textFieldLabel2={"value"}
          textFieldSetText2={set_secret_value}
          buttons={[
                    {"text":"Cancel" , "class":"modalCancel" , "onClick" : ()=>handle_close_modal() },
                    {"text":"Create" ,  "class": "modalOK", "onClick" : ()=> {update_secret(env ,secret_key , secret_value); handle_close_modal();} ,"disabled": !secret_key?.length || !secret_value?.length || !functions.valid(secret_value) || !functions.valid(secret_key) }
                  ]}
        /> 
        <Modal open={open_backend_edit_modal} onClose={()=>handle_close_modal} 
          title={"Edit secret"}
          text={"to edit the secret, please write the new value"}
          textField={true}
          textFieldLabel={"value"}
          textFieldSetText={set_secret_value}
          buttons={[
                    {"text":"Cancel" ,  "class":"modalCancel" , "onClick" : ()=>handle_close_modal() },
                    {"text":"Update" , "class": "modalOK", "onClick" : ()=>{update_secret(env ,secret_key , secret_value); handle_close_modal()} ,"disabled": !secret_value?.length || !functions.valid(secret_value) }
                  ]}
        /> 
        <Modal open={open_backend_delete_modal} onClose={()=>handle_close_modal} 
          title={`Delete secret`}
          text={`Are you sure you want to delete ${secret_key} secret?`}
          textField={false}
          buttons={[
                    {"text":"Cancel" ,  "class":"modalCancel" , "onClick" : ()=>handle_close_modal() },
                    {"text":"OK" , "class": "modalOK", "onClick" : ()=>{delete_secret(env ,secret_key , secret_value); handle_close_modal()} }
                  ]}
        />  
      </div>
  )
}